export default __webpack_public_path__ + "static/media/209.1120655d.gif";